import React, {PureComponent} from 'react'
import {Container, Segment, Step, Button, Accordion, Icon, Grid, Image} from 'semantic-ui-react'
import {isAuthenticated, showApiKey} from "../../services/self";
import DeveloperPortalConfiguration from "../../services/DeveloperPortalConfiguration";
import SubscribeDescription from "./SubscribeDescription";
import GettingStartedDescription from "./GettingStartedDescription";
import SwaggerApi from "./SwaggerApi";
import CodeExample from "../../components/CodeExample/CodeExample";
import Highlight from 'react-highlight'
import {CodeExampleCliAssumeRole, CodeExampleCloudFormationAssumeRole} from "../../components/CodeExample/CodeExample";

import BackgroundImg from './background.jpg';
import CloudFormationStackImg from './cloudformation-launch-stack.png';

const GettingStartedImg = {
    backgroundImage: 'linear-gradient(to right, #ffffff 50%, transparent), url('+BackgroundImg+')',
    backgroundPosition: '100% 40%'
}

const GettingStartedSegment = ({onNext}) => (
      <Segment.Group>
          <Segment clearing style={GettingStartedImg}>
            <GettingStartedDescription/>
            {!isAuthenticated() ? <SubscribeDescription/> : ''}
            <Button primary floated='right' onClick={onNext} content='Next' icon='right arrow' labelPosition='right'/>
          </Segment>
          <Segment textAlign='center'>
            <h4>This guide helps you get started using envimation CloudWatch Dashboard endpoint.</h4>
          </Segment>
      </Segment.Group>)

const CreatePolicySegment = ({onNext, activeIndex, handleClick, stackUrl}) => (
      <Segment.Group>
          <Segment clearing style={GettingStartedImg}>
            <Grid>
                <Grid.Column width={8}>
                    <h2>Create a trust policy</h2>
                    <p>Our api call requires us to manipulate resources on your behalf - such as listing your instances and creating the CloudWatch dashboard.</p>
                    <p>To enable us to do this we require you to tell AWS to trust us. You are required to create a least-privileged role.</p>
                    <p>We made it easy by creating a cloudformation template for you <a target="_blank" href="/aws/envimation-assume-role.cloudformation.yml">here</a>  or click the below button.</p>
                    <a href={stackUrl} target='_blank'><Image src={CloudFormationStackImg}/></a>
                </Grid.Column>
                <Grid.Column width={8}>
                </Grid.Column>
            </Grid>
            <Button primary floated='right' onClick={onNext} content='Next' icon='right arrow' labelPosition='right'/>
          </Segment>
          <Accordion as={Segment}>
            <Accordion.Title active={activeIndex === 0} index={0} onClick={handleClick}>
              <Icon name='dropdown' />
              Using CF template
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0}>
              <p>To deploy this template using the <strong>AWS</strong> command-line tool run the following command:</p>
              <CodeExampleCloudFormationAssumeRole/>
            </Accordion.Content>
          </Accordion>
          <Accordion as={Segment}>
            <Accordion.Title active={activeIndex === 1} index={1} onClick={handleClick}>
              <Icon name='dropdown' />
              Using cli-tool
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 1}>
              <p>Run the following command to create the required role:</p>
              <CodeExampleCliAssumeRole/>
            </Accordion.Content>
          </Accordion>
      </Segment.Group>)

const CreateDashboardSegment = ({snippet, apiId}) => (
      <Segment>
        <h2>Requesting a dashboard</h2>
        <p>Below you'll find an example <strong>curl</strong>-command. You'll need to pass the api-key as an
            'x-api-key' header, and provide your account id and desired region in order to form a proper service
            call.</p>
        <CodeExample text={snippet}/>
        <p>The response will look something like:</p>
        <Segment className="snippet">
            <Highlight className="bash">
                {`{"message":"dashboard Envimation-EC2 created, monitoring 4 instances in region eu-central-1"}`}
            </Highlight>
        </Segment>
        <p>Mandatory parameters are: </p>
        <p><strong>accountId</strong> - The accountId where the instances are running and where you have configured the
            envimation role.</p>
        <p><strong>region</strong> - The region where the instances are running</p>
        <p>Additional parameters are allowed in the body: </p>
        <p><strong>dashboardName</strong> - The name of the to be generated dashboard. "Envimation-EC2" by
            default</p>
        <p><strong>nameFilter</strong> - Filter the instances to be included. Regex value that is applied to the
            Name tag of your instances</p>
        <p><i>For full API definition and a playground checkout the <SwaggerApi apiId={apiId}/>.</i>
        </p>
      </Segment>)

export default class GettingStarted extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            active: 'getting-started',
            activeIndex: -1,
            apiKey: '<your-api-key>',
            usagePlanId: "tqhwyi",
            apiId: "93oimms10d"
        };
        }

    componentDidMount() {
        setTimeout(() => {
            if (isAuthenticated()) {
                showApiKey().then(apiKey => {
                    this.setState({apiKey})
                });
            }
        }, 1000)
    }


    snippet() {
        return `curl -X POST \\
    --header 'Content-Type: application/json' \\
    --header 'Accept: application/json' \\
    --header 'x-api-key: ` + this.state.apiKey + `' \\
    -d '{"accountId": "<YOUR_ACCOUNT_ID>", "region": "<DESIRED_REGION>"}' 'https://api.envimation.com/dashboards'`;
    }

    stackUrl() {
        var bucketName = DeveloperPortalConfiguration.siteS3Bucket;
        var region = DeveloperPortalConfiguration.awsRegion;
        var templateUrl = "https://s3." + region + ".amazonaws.com/" + bucketName + "/aws/envimation-assume-role.cloudformation.yml";
        return 'https://console.aws.amazon.com/cloudformation/home#/stacks/new?stackName=envimation-trust-role-stack&templateURL='+templateUrl;
    }

    showGettingStarted = () => {
        this.setState({active:'getting-started'})
    }
    showCreatePolicy = () => {
        this.setState({active:'create-policy'})
    }
    showCreateDashboard = () => {
        this.setState({active:'create-dashboard'})
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    render() {
        const { activeIndex } = this.state

        return (<Container>
            <br/>
            <Step.Group widths={3} fluid ordered>
              <Step
                  active={this.state.active === 'getting-started'}
                  link
                  onClick={this.showGettingStarted}
                  title='Getting started'
                  description='What do you get?' />
              <Step
                  active={this.state.active === 'create-policy'}
                  link
                  onClick={this.showCreatePolicy}
                  title='Create Policy'
                  description='Entrust Envimation access' />
              <Step
                  active={this.state.active === 'create-dashboard'}
                  link
                  onClick={this.showCreateDashboard}
                  title='Send request'
                  description='Create your dashboard' />
            </Step.Group>

            {this.state.active === 'getting-started' ? <GettingStartedSegment
                onNext={this.showCreatePolicy} /> : ''}
            {this.state.active === 'create-policy' ? <CreatePolicySegment
                activeIndex={activeIndex}
                handleClick={this.handleClick}
                onNext={this.showCreateDashboard}
                stackUrl={this.stackUrl()} /> : ''}
            {this.state.active === 'create-dashboard' ? <CreateDashboardSegment
                snippet={this.snippet()}
                apiId={this.state.apiId} /> : ''}

        </Container>)

  }
}


/** WEBPACK FOOTER **
 ** ./src/pages/GettingStarted/index.js
 **/